<div class="loaderwrapper" *ngIf="loader">
    <span class="loader"></span>
</div>

<section class="dashboard-main container-fluid">
    <div class="contents-main">
        <div class="col-12">
            <div class="card table-card">
                <!-- Title, filters and the page action share one row at the top
                     of the card rather than stacking above it. -->
                <div class="table-toolbar">
                    <h1 class="table-toolbar__title">Configuration</h1>
                </div>
                <div class="table-wrap" [class.is-loading]="tableLoader">
                    <div class="loaderwrapper" *ngIf="tableLoader">
                        <span class="loader"></span>
                    </div>
                    <div class="table-main">
                        <div>
                            <table class="table-data text-center">
                                <thead>
                                    <tr>
                                        <th scope="col" class="text-start">Sr. No</th>
                                        <th scope="col">USER TYPE</th>
                                        <th scope="col">Assign</th>
                                        <th scope="col">Start</th>
                                        <th scope="col">FSR</th>
                                        <th scope="col">On Hold</th>
                                        <th scope="col">Pending Material</th>
                                        <th scope="col">Reopen</th>
                                        <th scope="col">Resolvee</th>
                                        <th scope="col">Closed</th>
                                        <th scope="col">Cancel</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container *ngIf="!tableLoader; else LoadingRow">
                                        <tr *ngFor="let item of userTypePermission; let i = index">
                                            <td class="text-start">{{ item.srNo }}</td>
                                            <td>{{ item.user_type_name }}</td>
                                            <td>
                                                <input class="form-check-input static med" type="checkbox"
                                                    [(ngModel)]="item.assign"
                                                    (change)="onPermissionChange(item, 'assign', $event)" />
                                            </td>
                                            <td>
                                                <input class="form-check-input static med" type="checkbox"
                                                    [(ngModel)]="item.start"
                                                    (change)="onPermissionChange(item, 'start', $event)" />
                                            </td>
                                            <td>
                                                <input class="form-check-input static med" type="checkbox"
                                                    [(ngModel)]="item.fsr"
                                                    (change)="onPermissionChange(item, 'fsr', $event)" />
                                            </td>
                                            <td>
                                                <input class="form-check-input static med" type="checkbox"
                                                    [(ngModel)]="item.on_hold"
                                                    (change)="onPermissionChange(item, 'on_hold', $event)" />
                                            </td>
                                            <td>
                                                <input class="form-check-input static med" type="checkbox"
                                                    [(ngModel)]="item.pending_material"
                                                    (change)="onPermissionChange(item, 'pending_material', $event)" />
                                            </td>
                                            <td>
                                                <input class="form-check-input static med" type="checkbox"
                                                    [(ngModel)]="item.re_open"
                                                    (change)="onPermissionChange(item, 're_open', $event)" />
                                            </td>
                                            <td>
                                                <input class="form-check-input static med" type="checkbox"
                                                    [(ngModel)]="item.resolve"
                                                    (change)="onPermissionChange(item, 'resolve', $event)" />
                                            </td>
                                            <td>
                                                <input class="form-check-input static med" type="checkbox"
                                                    [(ngModel)]="item.close"
                                                    (change)="onPermissionChange(item, 'close', $event)" />
                                            </td>
                                            <td>
                                                <input class="form-check-input static med" type="checkbox"
                                                    [(ngModel)]="item.cancel"
                                                    (change)="onPermissionChange(item, 'cancel', $event)" />
                                            </td>
                                        </tr>
                                        <tr *ngIf="userTypePermission.length === 0">
                                            <td colspan="100%">
                                                <p class="not-found-message p-4 text-center">No records found.</p>
                                            </td>
                                        </tr>
                                    </ng-container>
                                </tbody>
                            </table>
                        </div>
                        <div class="table-meta">
                            <!-- <div class="entries flex-column align-items-start gap-3">
                            <label class="show-entries-list p-0">
                                Show
                                <select [formControl]="pageSizeControl" class="form-control form-control-sm"
                                    (change)="changePageSize()">
                                    <option *ngFor="let limit of pageRecordOptions" [value]="limit.value">
                                        {{ limit.label }}
                                    </option>
                                </select>
                                Entries
                            </label>
                            <span>Total Records: {{ this.total_items }}</span>
                        </div>
                        <nav class="table-pagination">
                            <ul>
                                <li>
                                    <div class="go-to-page d-flex align-items-center">
                                        <label>Go to Page:</label>
                                        <input type="number" class="form-control form-control-sm" [(ngModel)]="pageToGo"
                                            min="1" [max]="total_pages"
                                            (keydown.enter)="goToPage(pageToGo); pageToGo = null">
                                        <div class="input-group-append">
                                            <button class="btn btn-primary" type="button"
                                                (click)="goToPage(pageToGo); pageToGo = null"
                                                [disabled]="pageToGo < 1 || pageToGo > total_pages">Go</button>
                                        </div>
                                    </div>
                                </li>
                                <li><a class="init-bg" id="firstPage" (click)="goToPage(1)"
                                        [class.disabled]="current_page === 1">1</a></li>
                                <li><a class="no-bg" id="prevPage" (click)="navigatePage('prev')"><i
                                            class="fa fa-chevron-left"></i></a></li>
                                <li><a class="active">{{ current_page }}</a></li>
                                <li><a class="no-bg" id="nextPage" (click)="navigatePage('next')"
                                        [class.disabled]="current_page === total_pages"><i
                                            class="fa fa-chevron-right"></i></a></li>
                                <li><a class="init-bg" id="lastPage" (click)="goToPage(total_pages)"
                                        [class.disabled]="current_page === total_pages">{{ this.total_pages }}</a></li>
                            </ul>
                        </nav> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<ng-template #LoadingRow>
    <tr>
        <td colspan="100%">
            <div class="d-flex justify-content-center">
                <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </td>
    </tr>
</ng-template>